import { getPatientName } from "core/model/patients";
import { Patient } from "core/types";

const titleClasses =
  "PatientMenu-Title m-2 font-sans text-xl font-medium leading-6 text-gray-900 whitespace-nowrap text-start";

export function PatientIdentifier({ patient }: { patient: Patient }) {
  const patientName = getPatientName(patient);
  const patientId = patient.user_id ?? "";

  if (patientName)
    return (
      <h1 className={titleClasses}>
        <span className="font-bold" data-testid="patient-name">
          {patientName}
        </span>{" "}
        <span data-testid="patient-id">({patientId})</span>
      </h1>
    );

  return (
    <h1 className={titleClasses}>
      Patient <span data-testid="patient-id">{patientId}</span>
    </h1>
  );
}
